export default __webpack_public_path__ + "static/media/kycEnable.f5d54fd7.svg";